var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Deseja desarquivar o projeto: ")]),_c('strong',[_vm._v(" "+_vm._s(((_vm.item.project_code) + " - " + (_vm.item.project_name))))]),_c('br'),_c('div',{style:({
      paddingTop: '30px',
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      justifyContent: 'center',
    })},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.unArquiveProject}},[_vm._v("Desarquivar")]),_c('b-button',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.closeUnDeleteModal}},[_vm._v("Cancelar")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }